<template>
    <div class="Seguro-Colectivo-Salud">
        <div class="principal-title">
                <span>Seguros</span>
                <h1>Personales y familia</h1>
                <div id="contactForm">
                    <label for="">Conoce más sobre soluciones de seguros</label>
                    <div id="hubcontactForm"></div>
                </div>
        </div>
        <div class="info">
                <h1>Seguro de arrendamiento</h1>
                <p>
                Protección para tus ingresos
                <br>
                <br>
                Sabemos la tranquilidad que te genera saber que cada mes cuentas con el dinero que te pagan los inquilinos de tu propiedad, pero cuando no sea así, ¡no te preocupes! Tenemos la solución para que nunca dejes de recibir tus ingresos.
                </p>
        </div>
        <div class="table">
            <center>
                <h2>Elige el seguro de Arrendamiento que más se acomode a tus necesidades</h2>
                <div class="ms-rtestate-field">
                <div class="main-comparative">
                    <div class="comparative">
                        <div class="content-center">
                            <div class="boxes clearfix visible-md visible-lg" :class="{'vissible': display}">
                                <div class="col-md-10 col-md-offset-1">
                                    <div class="first row">
                                        <div class="col-md-4">
                                            <div class="col first">
                                                <div class="title">
                                                    <h3>Características</h3>
                                                </div>

                                                <ul>
                                                    <li>
                                                        <p>Medio para adquirirlo</p>
                                                    </li>
                                                    <li>
                                                        <p>Modalidad</p>
                                                    </li>
                                                    <li>
                                                        <p>Planes modalidad individual</p>
                                                    </li>
                                                    <li style="padding: 39px 20px;">
                                                        <p>Necesidad de codeudor</p>
                                                    </li>
                                                    <li>
                                                        <p>Valor del arriendo</p>
                                                    </li>
                                                    <li>
                                                        <p>Duración del contrato</p>
                                                    </li>
                                                    <li>
                                                        <p>Tipo de persona</p>
                                                    </li>
                                                    <li>
                                                        <p>Reclamaciones</p>
                                                    </li>
                                                    <li>
                                                        <p>Uso del inmueble</p>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div class="col-md-4">
                                            <div class="col">
                                                <div class="title">
                                                    <div class="insurance affix-top" data-spy="affix" data-offset-top="370">
                                                        <h3><small>Arrendamiento</small><br> Digital</h3>
                                                        <a class="btn yellow" target="_blank" href="https://www.suraenlinea.com/arrendamiento-digital/sura">Conócelo</a>
                                                    </div>
                                                </div>

                                                <ul>
                                                    <li>
                                                        <p><strong>100% digital</strong> y desde cualquier dispositivo</p>
                                                    </li>
                                                    <li>
                                                        <p>Individual</p>
                                                    </li>
                                                    <li>
                                                        <p>Individual</p>
                                                    </li>
                                                    <li>
                                                        <p>No <br><span style="font-size: 12px;">Si en algún punto del proceso digital no cumples con los requisitos, podrás continuar tu proceso con el producto tradicional.</span></p>
                                                    </li>
                                                    <li>
                                                        <p>Desde <strong>$400 000 hasta $2 500 000</strong></p>
                                                    </li>
                                                    <li>
                                                        <p>3, 6 o 12 meses</p>
                                                    </li>
                                                    <li>
                                                        <p>Natural (propietario e inquilino)</p>
                                                    </li>
                                                    <li>
                                                        <p>100% digital, desde cualquier dispositivo</p>
                                                    </li>
                                                    <li style="padding: 20px 20px;">
                                                        <p>Residencial</p>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div class="col-md-4">
                                            <div class="col">
                                                <div class="title">
                                                    <div class="insurance affix-top" data-spy="affix" data-offset-top="370">
                                                        <h3><small>Arrendamiento</small><br> Tradicional</h3>
                                                        <a class="btn yellow" target="_blank" href="https://www.segurossura.com.co/paginas/hogar/arrendamiento-tradicional.aspx">Conócelo</a>
                                                    </div>
                                                </div>

                                                <ul>
                                                    <li>
                                                        <p>Presencial, en la oficina de tu ciudad</p>
                                                    </li>
                                                    <li>
                                                        <p>Individual, colectiva</p>
                                                    </li>
                                                    <li>
                                                        <p>Global especial, global, clásico o básico</p>
                                                    </li>
                                                    <li style="padding: 43px 30px;">
                                                        <p>Sí</p>
                                                    </li>
                                                    <li style="padding: 15px 10px;">
                                                        <p>Según tu plan</p>
                                                    </li>
                                                    <li>
                                                        <p>Según tu plan</p>
                                                    </li>
                                                    <li>
                                                        <p>Natural y jurídica </p>
                                                    </li>
                                                    <li>
                                                        <p>Por medio de la oficina de tu ciudad</p>
                                                    </li>
                                                    <li style="padding: 20px 20px;">
                                                        <p>Según tu plan (residencial o comercial)</p>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="second row">
                                        <div class="col-md-4">
                                            <div class="col first">
                                                <div class="title cobertura">
                                                    <h3>Coberturas</h3>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-4">
                                            <div class="col">
                                                <ul>
                                                    <li>
                                                        <p>Pago del arriendo en caso de incumplimiento de tu inquilino</p>
                                                    </li>
                                                    <li>
                                                        <p>Pago de cuotas de administración</p>
                                                    </li>
                                                    <li>
                                                        <p>Asistencia domiciliaria (servicios de plomería, electricidad, cerrajería, reemplazo de vidrios, gastos de traslado y asistencia jurídica telefónica)</p>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div class="col-md-4">
                                            <div class="col">
                                                <ul>
                                                    <p>Según la modalidad y el plan que elijas:</p>
                                                    <h2>Coberturas básicas</h2>
                                                    <li>
                                                        <p>Pago del arriendo en caso de incumplimiento de tu inquilino</p>
                                                    </li>
                                                    <li>
                                                        <p>Pago de cuotas de administración</p>
                                                    </li>
                                                    <li>
                                                        <p>Servicios públicos domiciliarios pendientes en la entrega del inmueble</p>
                                                    </li>
                                                    <h2>Coberturas opcionales</h2>
                                                    <li>
                                                        <p>Daños y faltantes al inventario</p>
                                                    </li>
                                                    <li>
                                                        <p>Asistencia domiciliaria (servicios de plomería, electricidad, cerrajería, reemplazo de vidrios, gastos de traslado y asistencia jurídica telefónica)</p>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="third row">
                                        <div class="col-md-4">
                                            <div class="col first">
                                                <div class="title">
                                                    <h3>Requisitos</h3>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-4">
                                            <div class="col">
                                                <ul>
                                                    <li>
                                                        <p>Correo electrónico del inquilino</p>
                                                    </li>
                                                    <li>
                                                        <p>Número de la matrícula inmobiliaria</p>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div class="col-md-4">
                                            <div class="col">
                                                <ul>
                                                    <li>
                                                        <p>Diligenciamiento de formularios del inquilino</p>
                                                    </li>
                                                    <li>
                                                        <p>Codeudor</p>
                                                    </li>
                                                    <li>
                                                        <p>Copia de la cédula de ciudadanía del inquilino y el codeudor</p>
                                                    </li>
                                                    <li>
                                                        <p>Documentos que demuestren solvencia económica</p>
                                                    </li>
                                                    <li>
                                                        <p>Certificado de tradición y libertad reciente, no mayor a 30 días</p>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="fourth row">
                                        <div class="col-md-4">
                                            <div class="col first">
                                                <div class="title">
                                                    <h3>Límite de indemnización</h3>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-4">
                                            <div class="col">
                                                <p>En caso de reclamación, la cobertura se mantendrá hasta que se restituya el inmueble o hasta que el inquilino efectúe el pago de sus obligaciones,<strong> con un límite máximo de indemnización de  12 meses.</strong> El
                                                    seguro debe estar vigente y a paz y salvo.</p>
                                            </div>
                                        </div>

                                        <div class="col-md-4">
                                            <div class="col">
                                                <p>En caso de reclamación, la cobertura se mantendrá hasta que se restituya el inmueble o hasta que el inquilino efectúe el pago de sus obligaciones, <strong>con un límite máximo de indemnización de  36 meses, según el plan que elijas.</strong>                                    El seguro debe estar vigente y a paz y salvo.</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12 m-top text-center">
                                            <p>*Si en algún punto del proceso digital no cumples con los requisitos, podrás continuar tu proceso con el producto tradicional.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <table class="hidden-md hidden-lg" width="100%" :class="{'vissible': !display}">
                                <tbody>
                                    <tr>
                                        <td>
                                            <table class="table-striped" width="100%">
                                                <tbody>
                                                    <tr>
                                                        <td height="107" align="center" class="cp">
                                                            <div class="title">
                                                                <div class="insurance" data-spy="affix" data-offset-top="370">
                                                                    <h3><small>Arrendamiento</small><br> Digital</h3>
                                                                    <a class="btn yellow" target="_blank" href="https://www.segurossura.com.co/arrendamiento-digital/paginas/arrendamiento.aspx">Conócelo</a>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td height="107" align="center" class="cp">
                                                            <div class="title">
                                                                <div class="insurance" data-spy="affix" data-offset-top="370">
                                                                    <h3><small>Arrendamiento</small><br> Tradicional</h3>
                                                                    <a class="btn yellow" target="_blank" href="https://www.segurossura.com.co/paginas/hogar/arrendamiento-tradicional.aspx">Conócelo</a>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <table class="table-striped" width="100%">
                                                <tbody>
                                                    <tr>
                                                        <td align="center" colspan="2">
                                                            <div class="title">
                                                                <h3>Características</h3>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <p><strong>Medios para adquirirlo: </strong><br>100% digital y desde cualquier dispositivo</p>
                                                        </td>
                                                        <td>
                                                            <p><strong>Medios para adquirirlo: </strong><br>Presencial, en la oficina de tu ciudad</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <p><strong>Necesidad de codeudor: </strong><br>No, <span style="font-size: 12px;">si en algún punto del proceso digital no cumples con los requisitos, podrás continuar tu proceso con el producto tradicional.</span></p>
                                                        </td>
                                                        <td>
                                                            <p><strong>Necesidad de codeudor: </strong><br>Sí</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <p>Digital</p>
                                                        </td>
                                                        <td>
                                                            <p>Global especial, global, clásico y básico</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <p><strong>Valor del arriendo:</strong><br>desde $400 000 hasta $1 800 000</p>
                                                        </td>
                                                        <td>
                                                            <p><strong>Valor del arriendo:</strong><br>desde $400 000 en adelante</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <p><strong>Duración del contrato:</strong><br> 3, 6 o 12 meses</p>
                                                        </td>
                                                        <td>
                                                            <p><strong>Duración del contrato:</strong><br> 3, 6 o 12 meses</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <p><strong>Tipo de persona:</strong><br>Natural (propietario e inquilino)</p>
                                                        </td>
                                                        <td>
                                                            <p><strong>Tipo de persona:</strong><br>Natural y jurídica</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <p><strong>Reclamaciones:</strong><br>100% digital, desde cualquier dispositivo</p>
                                                        </td>
                                                        <td>
                                                            <p><strong>Reclamaciones:</strong><br>Por medio de la oficina de tu ciudad</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <p><strong>Uso del inmueble:</strong><br>Residencial</p>
                                                        </td>
                                                        <td>
                                                            <p><strong>Uso del inmueble:</strong><br>Comercial y residencial o solo residencial, según el plan que elijas.</p>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <table class="table-striped" width="100%">
                                                <tbody>
                                                    <tr>
                                                        <td align="center" colspan="2">
                                                            <div class="title">
                                                                <h3>Coberturas básicas</h3>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="50%">
                                                            <p>Pago del arriendo en caso de incumplimiento de tu inquilino</p>
                                                        </td>
                                                        <td width="50%">
                                                            <p>Pago del arriendo en caso de incumplimiento de tu inquilino</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <p>Pago de cuotas de administración</p>
                                                        </td>
                                                        <td>
                                                            <p>Pago de cuotas de administración</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <p>Asistencia domiciliaria (servicios de plomería, electricidad, cerrajería, reemplazo de vidrios, gastos de traslado y asistencia jurídica telefónica)</p>
                                                        </td>
                                                        <td>
                                                            <p>Servicios públicos domiciliarios pendientes en la entrega del inmueble</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>&nbsp;</td>
                                                        <td>
                                                            <p>Daños y faltantes al inventario</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>&nbsp;</td>
                                                        <td>
                                                            <p>Asistencia domiciliaria (servicios de plomería, electricidad, cerrajería, reemplazo de vidrios, gastos de traslado y asistencia jurídica telefónica)</p>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <table class="table-striped" width="100%">
                                                <tbody>
                                                    <tr>
                                                        <td align="center" colspan="2">
                                                            <div class="title">
                                                                <h3>Requisitos</h3>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="50%">
                                                            <p>Correo electrónico del inquilino</p>
                                                        </td>
                                                        <td width="50%">
                                                            <p>Diligenciamiento de formularios del inquilino</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <p>Número de la matricula inmobiliaria</p>
                                                        </td>
                                                        <td>
                                                            <p>Codeudor</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>&nbsp;</td>
                                                        <td>
                                                            <p>Copia de la cédula de ciudadanía del inquilino y el codeudor</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>&nbsp;</td>
                                                        <td>
                                                            <p>Documentos que demuestren solvencia económica</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>&nbsp;</td>
                                                        <td>
                                                            <p>Certificado de tradición y libertad reciente, no mayor a 30 días</p>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <table class="table-striped" width="100%">
                                                <tbody>
                                                    <tr>
                                                        <td align="center" colspan="2">
                                                            <div class="title">
                                                                <h3>Límite de indemnización</h3>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="50%">
                                                            <p>En caso de reclamación, la cobertura se mantendrá hasta que se restituya el inmueble o hasta que el inquilino efectúe el pago de sus obligaciones,<strong> con un límite máximo de indemnización de 12 meses.</strong>                                                El seguro debe estar vigente y a paz y salvo.</p>
                                                        </td>
                                                        <td width="50%">
                                                            <p>En caso de reclamación, la cobertura se mantendrá hasta que se restituya el inmueble o hasta que el inquilino efectúe el pago de sus obligaciones,<strong> con un límite máximo de indemnización de 36 meses. </strong>                                                El seguro debe estar vigente y a paz y salvo.</p>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <table class="table-striped" width="100%">
                                                <tbody>
                                                    <tr>
                                                        <td align="center" colspan="2">
                                                            <div class="col-md-12 text-center">
                                                                <p>*Si en algún punto del proceso digital no cumples con los requisitos, podrás continuar tu proceso con el producto tradicional.</p>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            </center>
        </div>
        <Aliados/>
    </div>
</template>

<script>
import Aliados from '../../utilitis/aliados'
import VueSlickCarousel from 'vue-slick-carousel'

export default {
    name: 'Cuadro',
    components: {
        Aliados,
        VueSlickCarousel
    },
    data() {
        return {
            display: null,
            services: [
                {
                    type: true,
                    img: require('@/assets/Servicio1.png'),
                    label: '¿Qué cubre?'
                }
            ],
            coberturaOpcional: [
                {
                    label: 'Muerte accidental',
                    p: 'Si falleces en un accidente o como producto de él, siempre y cuando la muerte ocurra dentro de los 180 días siguientes al hecho, les daremos a tus beneficiarios una indemnización por el valor que contrataste desde un principio.'
                },
                {
                    label: 'Invalidez, desmembración o inutilización por accidente',
                    p: 'En caso sufrir un accidente en el que termines con alguna invalidez total o pérdida funcional de ciertos órganos o partes de tu cuerpo, te daremos una indemnización equivalente al porcentaje de invalidez, de esa manera conservas tu independencia económica y sostienes los gastos que pueda traer consigo este hecho.'
                }
            ],
            slickOptionsExperiencies: {
                'dots': false,
                'arrows': true,
                'focusOnSelect': true,
                'infinite': true,
                'autoplay': true,
                'autoplaySpeed': 3000,
                'speed': 500,
                'slidesToShow': 3,
                'slidesToScroll': 3,
                'touchThreshold': 5,
                'responsive': [
                    {
                        'breakpoint': 1140,
                        'settings': {
                            'slidesToShow': 2,
                            'slidesToScroll': 2,
                            'infinite': true
                        }
                    },
                    {
                        'breakpoint': 680,
                        'settings': {
                            'slidesToShow': 1,
                            'slidesToScroll': 1,
                            'infinite': true
                        }
                    }
                ]
            },
            especialidades: [
                {
                    image: require('@/assets/Accidentes-personales/1.png'),
                    texto: 'Estar tranquilo porque tus beneficiarios recibirán una indemnización en caso de que fallezcas en un accidente o como consecuencia de este.'
                },
                {
                    image: require('@/assets/Accidentes-personales/2.png'),
                    texto: 'Recibir una renta diaria durante el tiempo que tarde tu recuperación para que tú y tus seres queridos no pierdan su calidad de vida.'
                },
                {
                    image: require('@/assets/Accidentes-personales/3.png'),
                    texto: 'Contar con apoyo económico si quedas con una invalidez o desmembración a causa de un accidente.'
                },
                {
                    image: require('@/assets/Accidentes-personales/4.png'),
                    texto: 'Tener la posibilidad de recibir reembolsos por los gastos médicos en que incurras a consecuencia de un accidente.'
                }
            ]
        }
    },
    created() {
        window.addEventListener('resize', this.myEventHandler)
    },
    destroyed() {
        window.removeEventListener('resize', this.myEventHandler)
    },
    beforeMount() {
        this.$root.$emit('change_url', this.$route.name)
    },
    mounted() {
        window.hbspt.forms.create({
            region: 'na1',
            portalId: '5573496',
            formId: '4cd61e34-58c1-4068-accb-dae3eeb5e789',
            target: '#hubcontactForm'
        })
        if (window.innerWidth < 990) {
            this.display = true
        } else {
            this.display = false
        }
    },
    methods: {
        myEventHandler(e) {
            if (window.innerWidth < 990) {
                this.display = true
            } else {
                this.display = false
            }
        }
    }
}
</script>
<style>
    .boxes{
        padding: 50px 100px;
    }
    .cobertura-principal-slide > p > span {
        font-weight: bold;
        margin-left: 5em;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots {
        z-index: 99999999;
        bottom: 25px;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots > li {
        width: 30px;
        height: 1px;
        list-style-type: none;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots > li > button {
        border: 0px;
        border-style: solid;
        border-color:#2d4f98;
        color: #2d4f98;
        background-color: #2d4f98;
        width: 100%;
        height: 5px;
        list-style-type: none;
        padding: 0;
        border-radius: 5px;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots li button:before {
        content: none;
        padding: 0;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots li button:hover{
        border-color:#2d4f98;
        color: #2d4f98;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots li button:active{
        background-color: #000;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots {
        z-index: 99999999;
        bottom: 5px;
        margin-bottom: 15px;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots > li {
        width: 30px;
        height: 1px;
        list-style-type: none;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots > li > button {
        border: 0px;
        border-style: solid;
        border-color:#2d4f98;
        color: #2d4f98;
        background-color: #2d4f98;
        width: 100%;
        height: 5px;
        list-style-type: none;
        padding: 0;
        border-radius: 5px;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots li button:before {
        content: none;
        padding: 0;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots li button:hover{
        border-color:#2d4f98;
        color: #2d4f98;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots li button:active{
        background-color: #000;
    }
</style>

<style scoped>
    .vissible {
        display: none;
    }
    h3 {
        font-size: 16px;
        color: #2d4f98;
        font-weight: 700;
        margin-bottom: 10px;
        margin-top: 20px;
    }
    .principal-title {
        background-image: url('../../../assets/servicios-bg-personas-familias.png');
        padding: 200px 300px;
        color: #fff;
        background-position: center;
        background-repeat: no-repeat;
    }
    .principal-title > span {
        font-family: 'JLI';
        font-size: 40px;
    }
    .principal-title > h1 {
        font-family: 'JBD';
        font-size: 50px;
    }
    #contactForm {
        margin-top: -100px;
        font-family: 'JR';
        background-color: #fff;
        padding: 40px;
        position: absolute;
        border-radius: 10px;
        width: 400px;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        font-weight: bolder;
        right: 100px;
    }
    #contactForm > label {
        color: #65b24a;
        font-size: 24px;
        line-height: 25px;
    }
    .info {
        padding: 100px 0px;
    }
    .info > h1 {
        font-family: 'JBD';
        color: #65b24a;
        padding-left: 300px;
        font-size: 40px;
        width: 60%;
    }
    .info > p {
        font-family: 'JR';
        width: 60%;
        padding-left: 300px;
        margin-top: 10px;
        font-size: 18px;
    }
    .slider2 {
        width: 70%;
    }
    .especialidades-slide{
        padding-top: 40px;
    }
    .especialidades-slide > center > h1 {
        font-family: 'JBD';
        color: #2d4f98;
        font-size: 30px;
    }
    .especialidades > div {
        height: 500px;
    }
    .especial img {
        width: 100%;
        -webkit-user-drag: none;
        -khtml-user-drag: none;
        -moz-user-drag: none;
        -o-user-drag: none;
        user-drag: none;
    }
    .especial > p {
        font-family: 'JR';
        padding: 10px;
        text-align: left;
    }
    .texto {
        width: 100%;
        padding: 10px 300px;
    }
    .texto > center > h1 {
        color: #2d4f98;
        font-family: 'JBD';
    }
    .texto > .box-title {
        margin-top: 50px;
        margin-bottom: 50px;
    }
    .texto > .box-title > h1 {
        color: #2d4f98;
        font-family: 'JBD';
    }
    .texto > .box {
        padding: 20px 20px;
        text-align: left;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        margin-bottom: 10px;
    }
    .texto > center > label {
        font-family: 'JBD';
        color: #65b24a;
    }
    .texto > center > p {
        font-family: 'JR';
    }
    .texto > center > p > span{
        font-weight: bold;
        color: #2d4f98;
    }
    .service {
        padding: 20px 300px;
        width: 100%;
    }
    .service > div {
        width: 100%;
        margin-top: 20px;
    }
    .service > div {
        width: 100%;
        display: flex;
    }
    .service > div > div > img {
        width: 350px;
        float: left;
    }
    .service > div > .imgbox {
        display: block;
        width: 350px;
        z-index: 99999;
    }
    .service > div > .box {
        margin-left: -300px;
        margin-top: 110px;
        background-color: #fff;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        width: 92%;
        height: auto;
        padding: 30px 30px 30px 350px;
    }
    .service > div > .box > div > img {
        width: 70px;
        margin-left: 15px;
        margin-right: 10px;
    }
    .service > div > .box > label {
        font-weight: bold;
        padding: 20px;
    }
    .service > div > .box > div > label {
        font-family: 'JBD';
        color: #65b24a;
    }
    .service > div > .box2 {
        margin-right: -300px;
        margin-top: 60px;
        background-color: #fff;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        width: 92%;
        height: auto;
        padding: 30px 350px 100px 30px;
    }
    .service > div > .right{
        position: absolute;
        right: 15%;
    }
    .service > div > .box > h1 {
        position: relative;
        font-family: 'JBD';
        color:#2d4f98;
        margin-top: -120px;
        margin-bottom: 60px;
        text-align: left;
    }
    .service > div > .box > div > div {
        font-family: 'JR';
        margin-bottom: 15px;
    }
    .service > div > .box2 > h1 {
        position: relative;
        font-family: 'JBD';
        color: #2d4f98;
        margin-bottom: 10px;
        margin-top: -120px;
        text-align: right;
        margin-bottom: 60px;
    }
    .service > div > .box2 > div > div {
        font-family: 'JR';
        margin-bottom: 15px;
    }
    .service > div > .box > div > div > p > span{
        color:#65b24a;
        font-family: 'JBD';
    }
    .facirclecheck-service {
        margin-right: 4px;
        margin-top: 4px;
        font-weight: bolder;
        color: #2d4f98;
        width: 15px;
        height: 15px;
        float: left;
    }
    .cobertura-principal {
        width: 100%;
        padding: 0px 300px;
    }
    .cobertura-principal > center > h1 {
        color: #2d4f98;
        font-family: 'JBD';
        margin-top: 50px;
    }
    .cobertura-principal > div {
        display: flex;
        margin-bottom: 50px;
    }
    .cobertura-principal > div > center > img {
        width: 200px;
        height: auto;
    }
    .cobertura-principal > div > div {
        padding: 20px;
    }
    .cobertura-principal > div > div > div > img{
        width: 50px;
        margin-right: 20px;
    }
    .cobertura-principal > div > div > div > label{
        font-family: 'JBD';
        color: #65b24a;
        font-size: 20px;
    }
    .cobertura-principal > div > div {
        padding: 25px;
        margin-top: 20px;
        font-family: 'JR';
        -webkit-box-shadow: 10px 10px 26px 26px rgba(0,0,0,0.04);
        -moz-box-shadow: 10px 10px 26px 26px rgba(0,0,0,0.04);
        box-shadow: 10px 10px 26px 26px rgba(0,0,0,0.04);
    }
    .cobertura-principal-slide{
        padding: 0px 300px;
    }
    .cobertura-principal-slide > div {
        display: flex;
    }
    .cobertura-principal-slide > div > label {
        color: #65b24a;
        font-family: 'JBD';
        font-size: 20px;
    }
    .cobertura-principal-slide > div > img {
        width: 50px;
    }
    .cobertura-principal-slide > p {
        font-family: 'JR';
        margin-top: 10px;
        margin-bottom: 60px;
    }
    .slide-cobertura-opcional > center > label {
        color: #65b24a;
        font-family: 'JBD';
    }
    .slide-cobertura-opcional > center > h1 {
        color: #2d4f98;
        font-family: 'JBD';
        margin-top: 50px;
        margin-bottom: 50px;
    }
    .ofrecemos {
        padding: 50px 300px;
    }
    .ofrecemos > center > h1 {
        font-family: 'JBD';
        color: #2d4f98;
    }
    .ofrecemos > label {
        color: #65b24a;
        font-family: 'JBD';
    }
    .opcionales {
        padding: 50px 300px;
        font-family: 'JR';
    }
    .opcionales > center > h1 {
        color: #2d4f98;
        font-family: 'JBD';
        margin-bottom: 20px;
    }
    .opcionales > .opcional > .subopcional {
        padding-left: 50px;
    }
    .connect {
        background: -prefix-linear-gradient(left, #2d4f98, #65b24a);
        background: linear-gradient(to right, #2d4f98 30%, #65b24a);
        height: 200px;
        width: 100%;
    }
    .connect > img {
        position: absolute;
        height: 200px;
        width: 380px;
        right: 0;
        object-fit: cover;
        object-position: 75px -70px;
    }
    .connect > h1 {
        font-family: 'JBD';
        padding-top: 50px;
        padding-left: 200px;
        color: #65b24a;
    }
    .connect > p{
        font-family: 'JR';
        padding-left: 200px;
        width: 80%;
        color: #fff;
        font-size: 22px;
        line-height: 25px;
    }
    .move > center > img {
        margin-top: 30px;
        width: 800px;
    }
    .main-comparative .comparative .boxes .row {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    }
    .row {
        margin-left: -15px;
        margin-right: -15px;
    }
    .main-comparative .comparative .boxes .row .col-md-4 {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    }
    .main-comparative .comparative .boxes .row .col.first {
        background-color: transparent;
        border: none;
        border-bottom: 1px solid #eee;
    }
    .main-comparative .comparative .boxes .row.first .col {
        border-radius: 5px 5px 0 0;
        padding: 10px;
        display: block;
        -webkit-box-pack: inherit;
        -ms-flex-pack: inherit;
        justify-content: inherit;
        -webkit-box-align: inherit;
        -ms-flex-align: inherit;
        align-items: inherit;
        padding-left: 0;
        padding-right: 0;
    }
    .main-comparative .comparative .boxes .row.first .col.first .title {
        padding: 40px 0;
        min-height: inherit;
    }
    .main-comparative .comparative .boxes .row.first .col .title {
        min-height: 110px;
    }
    .main-comparative .comparative .boxes .row .col.first .title h3 {
    margin: 0;
    }
    .main-comparative .comparative .title h3 {
        color: #333;
        font-family: 'JR';
        font-size: 30px;
        margin: 0;
    }
    ul {
        margin: 0;
        padding: 0;
    }
    ul, ol {
        margin-top: 0;
        margin-bottom: 10px;
    }
    .main-comparative .comparative .boxes .row.first .col.first ul li {
        text-align: left;
        padding: 15px 25px;
    }
    .main-comparative .comparative .boxes .row.first .col ul li {
        text-align: center;
    }
    .main-comparative .comparative .boxes .row.first ul li:nth-child(odd) {
        padding: 15px 10px;
        border-radius: 50px;
        border: 1px solid #eee;
        background-color: #f8f8f8;
        max-height: 50px;
        min-height: 50px;
    }
    .main-comparative .comparative .boxes .row .col ul li {
        position: relative;
        padding-left: 15px;
    }
    .main-comparative .comparative .boxes .row.first ul li {
        padding: 15px 10px;
    }
    ul li {
        list-style: none;
    }
    .main-comparative .comparative .boxes .row .col.first .title h3 {
        margin: 0;
    }
    .main-comparative .comparative .title h3 {
        color: #333;
        font-family: 'JR';
        font-size: 30px;
        margin: 0;
    }
    .main-comparative .comparative .boxes .row.first ul {
        padding: 0 10px;
    }
    .main-comparative .comparative .boxes .row.first .col.first ul li p {
        font-weight: 500;
    }
    .main-comparative .comparative .boxes .row .col-md-4 {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    }
    .main-comparative .comparative .boxes .row.first .col {
        border-radius: 5px 5px 0 0;
        padding: 10px;
        display: block;
        -webkit-box-pack: inherit;
        -ms-flex-pack: inherit;
        justify-content: inherit;
        -webkit-box-align: inherit;
        -ms-flex-align: inherit;
        align-items: inherit;
        padding-left: 0;
        padding-right: 0;
    }
    .main-comparative .comparative .boxes .row .col {
        background-color: #fdfdfd;
        border: 1px solid #eee;
        padding: 10px 20px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: left;
        -ms-flex-pack: left;
        justify-content: left;
        width: 100%;
    }
    .main-comparative .comparative .boxes .row:nth-child(2n) .col {
        background-color: #f8f8f8;
    }
    .main-comparative .comparative .boxes .row .col {
        background-color: #fdfdfd;
        border: 1px solid #eee;
        padding: 10px 20px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: left;
        -ms-flex-pack: left;
        justify-content: left;
        width: 100%;
    }
    .main-comparative .comparative .boxes .row .col ul li {
        position: relative;
        padding-left: 15px;
    }
    ul li {
        list-style: none;
    }
    .main-comparative .comparative .boxes .row.first .col .title {
        min-height: 110px;
    }
    .main-comparative .comparative .boxes .row.first .col .title .insurance {
        -webkit-transition: all .2s ease;
        -o-transition: all .2s ease;
        transition: all .2s ease;
    }
    .main-comparative .comparative .title .insurance {
        text-align: center;
    }
    .main-comparative .comparative .title .insurance h3 {
        color: #2d4f98;
        font-size: 25px;
        font-family: 'JR';
        margin-bottom: 10px;
    }
    .main-comparative .comparative .title h3 {
        color: #333;
        font-family: 'JR';
        font-size: 30px;
        margin: 0;
    }
    .main-comparative .comparative .title .insurance h3 small {
        color: #2d4f98;
        font-size: 25px;
    }
    .main-comparative .comparative .title .insurance a {
        border-radius: 20px;
        padding: 3px;
        max-width: 140px;
        font-weight: 500;
        font-family: 'JR';
    }
    .btn.yellow {
        background-color: #65b24a;
        color: #2d4f98;
    }
    .btn {
        display: block;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        font-size: 16px;
        font-weight: 700;
        padding: 16px;
        margin: 0 auto;
        max-width: 230px;
    }
    .main-comparative .comparative .boxes .row .col.first .title h3 {
        margin: 0;
    }

    .main-comparative .comparative .title h3 {
        color: #333;
        font-family: 'JR';
        font-size: 30px;
        margin: 0;
    }
    .main-comparative .comparative .boxes .second .col ul li:before {
        margin-top: 4px;
        background-color: #00aec7;
        border-radius: 50%;
        content: "";
        height: 5px;
        top: 7px;
        left: 0;
        position: absolute;
        width: 5px;
    }
    .main-comparative .comparative .boxes .second .col ul li {
        position: relative;
        padding-left: 15px;
        text-align: left;
    }
    .main-comparative .comparative .boxes .second .col ul li p{
        position: relative;
        padding-left: 15px;
        text-align: left;
    }
    .main-comparative .comparative .boxes .third .col ul li {
        position: relative;
        padding-left: 15px;
        text-align: left;
    }
    .main-comparative .comparative .boxes .third .col ul li p{
        position: relative;
        padding-left: 15px;
        text-align: left;
    }
    .main-comparative .comparative .boxes .third .col ul li:before {
        margin-top: 4px;
        background-color: #00aec7;
        border-radius: 50%;
        content: "";
        height: 5px;
        top: 7px;
        left: 0;
        position: absolute;
        width: 5px;
    }
    .fourth .col-md-4 .first .title{
        text-align: left;
    }
    .main-comparative .comparative .boxes .row:nth-child(2n) .col {
        background-color: #f8f8f8;
    }
    .main-comparative .comparative .boxes .row:nth-child(2n) .first {
        background-color: #fff;
    }
    .fourth .col-md-4 .col p{
        text-align: left;
    }
    .table > center > h2 {
        color: #2d4f98;
    }
    @media (min-width: 992px)
    .col-md-4 {
        width: 33.33333333%;
    }
    @media (min-width: 992px)
        .col-md-offset-1 {
            margin-left: 8.33333333%;
        }
        @media (min-width: 992px)
        .col-md-10 {
            width: 83.33333333%;
    }
    @media (max-width: 1600px) {
        .slider2 {
            width: 60%;
        }
    }
    @media (max-width: 1500px) {
        .principal-title {
            padding: 200px 200px;
        }
        .info > h1 {
            padding-left: 200px;
        }
        .info > p {
            padding-left: 200px;
        }
        .slider2 {
            width: 65%;
        }
    }
    @media (max-width: 1400px) {
        .principal-title {
            padding: 200px 100px;
        }
        .info > h1 {
            padding-left: 100px;
        }
        .info > p {
            padding-left: 100px;
        }
        .services {
            padding: 50px 100px;
            width: 100%;
        }
        .service {
            padding: 20px 150px;
            width: 100%;
        }
        .slider2 {
            width: 70%;
        }
    }
    @media (max-width: 1300px) {
        .boxes{
            padding: 50px 75px;
        }
        .info > h1 {
            font-size: 30px;
        }
        .info > p {
            width: 50%;
        }
        .texto {
            width: 100%;
            padding: 10px 200px;
        }
        .cobertura-principal {
            width: 100%;
            padding: 10px 200px;
        }
        .cobertura-principal-slide{
            padding: 0px 200px;
        }
        .opcionales {
            padding: 50px 200px;
        }
        .ofrecemos {
            padding: 50px 200px;
        }
        .slider2 {
            width: 75%;
        }
    }
    @media (max-width: 1200px) {
        .boxes{
            padding: 50px 50px;
        }
        .service {
            padding: 20px 75px;
            width: 100%;
        }
        .service > div > .right{
            position: absolute;
            right: 10%;
        }
    }
    @media (max-width: 1100px) {
        .boxes{
            padding: 50px 25px;
        }
        .service {
            padding: 20px 50px;
            width: 100%;
        }
        .service > div > .right{
            position: absolute;
            right: 5%;
        }
        .connect > h1 {
            padding-top: 10px;
            padding-left: 100px;
            z-index: 99999999;
            position: sticky;
        }
        .connect > p{
            padding-left: 100px;
            z-index: 99999999;
            position: sticky;
        }
        #contactForm {
            margin-top: -100px;
            right: 50px;
        }
        .slider2 {
            width: 80%;
        }
    }
    @media (max-width: 1000px) {
        .principal-title {
            padding: 50px 0px;
            height: 400px;
            text-align: center;
        }
        #contactForm {
            margin-top: 10px;
            left: 0;
            right: 0;
            margin: auto;
        }
        .info {
            padding-top: 400px;
            width: 100%;
            text-align: center;
        }
        .info > h1 {
            width: 100%;
            padding: 10px;
            text-align: center;
        }
        .info > p {
            width: 100%;
            text-align: center;
            padding: 10px;
        }
        .texto {
            width: 100%;
            padding: 10px 100px;
        }
        .services {
            padding: 0px 50px;
        }
        .service {
            padding: 20px 25px;
            width: 100%;
        }
        .connect > h1 {
            padding-left: 50px;
            font-size: 30px;
        }
        .connect > p{
            padding-left: 50px;
            font-size: 18px;
        }
        .cobertura-principal {
            width: 100%;
            padding: 10px 100px;
        }
        .cobertura-principal-slide{
            padding: 0px 100px;
        }
        .opcionales {
            padding: 50px 100px;
        }
        .ofrecemos {
            padding: 50px 100px;
        }
    }
    @media (max-width: 900px) {
        .colectivo > center > div {
            display: block;
        }
        .move > center > img {
            width: 700px;
        }
    }
    @media (max-width: 800px) {
        .services > center > div > div {
            display: block;
            width: 60%;
            float: none;
        }
        .service > div {
            display: grid;
        }
        .service > div > .box{
            margin-left: 0px;
            margin-top: 0px;
            width: 100%;
            padding: 30px 30px 30px 30px;
        }
        .service > div > .box2 {
            margin-right: 0px;
            margin-top: 0px;
            background-color: #fff;
            width: 100%;
            padding: 30px 30px 100px 30px;
        }
        .service > div > .imgbox {
            display: block;
            width: 100%;
            display: flex;
            justify-content: center;
        }
        .service > div > .imgbox > img{
            width: 250px;
            margin: auto;
        }
        .service > div > .right{
            position: relative;
            right: 0px;
        }
        .service > div > .box2 > h1 {
            margin-top: 0px;
            margin-bottom: 20px;
            text-align: left;
        }
        .service > div > .box > h1 {
            margin-top: 0px;
            margin-bottom: 20px;
            text-align: left;
        }
        .cobertura-principal > div {
            display: block;
        }
        .move > center > img {
            width: 600px;
        }
    }
    @media (max-width: 700px) {
        .texto {
            width: 100%;
            padding: 10px 50px;
        }
        .cobertura-principal {
            padding: 10px 50px;
        }
        .cobertura-principal-slide {
            padding: 0px 50px;
        }
        .opcionales {
            padding: 50px 50px;
        }
        .ofrecemos {
            padding: 50px 50px;
        }
        .move > center > img {
            width: 500px;
        }
    }
    @media (max-width: 600px) {
        .connect > h1 {
            font-size: 18px;
        }
        .connect > p{
            font-size: 18px;
            width: 100%;
        }
        .services > center > div > div {
            width: 70%;
        }
        .move > center > img {
            width: 400px;
        }
    }
    @media (max-width: 500px) {
        .texto > .box-title > h1 {
            font-size: 30px;
        }
        #contactForm {
            width: 300px;
        }
        .connect > h1 {
            padding-left: 25px;
        }
        .connect > p{
            padding-left: 25px;
        }
        .services > center > div > div {
            width: 80%;
        }
        .slide-cobertura-opcional > center > h1 {
            font-size: 30px;
        }
        .cobertura-principal > center > h1{
            font-size: 30px;
        }
        .opcionales > center > h1 {
            font-size: 30px;
        }
        .ofrecemos > center > h1 {
            font-size: 30px;
        }
        .move > center > img {
            width: 300px;
        }
    }
    @media (max-width: 400px) {
        .services > center > div > div {
            width: 90%;
        }
        .connect > p{
            padding-left: 5px;
            font-size: 16px;
            line-height: 19px;
        }
        .move > center > img {
            width: 250px;
        }
        .especial img {
            width: 240px;
        }
        .cobertura-principal > div > div {
            padding: 20px 0px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Servicios/ServiciosPersonas/Cuadro.vue